<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg">
          <v-toolbar color="#f8f9fb" elevation="0">
            <v-toolbar-title>{{
              $t("society.requestDetails.title")
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              color="green"
              text
              dark
              class="d-none d-sm-flex"
              @click="confirmAcceptSocietyRequest"
              :loading="loading"
            >
              <v-icon left> mdi-check-bold </v-icon>
              {{ $t("society.requestDetails.buttons.approve") }}
            </v-btn>

            <v-btn
              color="red"
              text
              dark
              @click="confirmRejectSocietyRequest"
              :loading="loading"
              class="mr-2 d-none d-sm-flex"
            >
              <v-icon left> mdi-close </v-icon>
              {{ $t("society.requestDetails.buttons.reject") }}
            </v-btn>

            <v-btn color="primary" @click="$router.go(-1)">
              <v-icon left> mdi-chevron-double-left </v-icon>
              {{ $t("society.requestDetails.buttons.back") }}
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="#f4f5f7 black--text">
            <v-row>
              <v-col cols="12" class="ml-2 mt-5">
                <v-avatar
                  size="100"
                  v-if="society && society.logo_url != null"
                  class="cursor-pointer ml-3"
                >
                  <v-img
                    :src="API_BASE_URL + '/uploads/' + society.logo_url"
                    :alt="society.name"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-avatar>
                <v-avatar
                  v-else
                  color="success"
                  class="white--text cursor-pointer ml-3"
                  size="100"
                >
                  <span class="fontsize-11">{{ society.name.charAt(0) }}</span>
                </v-avatar>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="6">
                <v-row>
                  <v-col cols="6" sm="5" md="5" lg="5">
                    <span class="font-weight-bold"
                      >{{ $t("society.requestDetails.residentType") }} :
                    </span>
                  </v-col>
                  <v-col cols="6" sm="7" md="7" lg="7">
                    <span>{{ residentType(society.type) }}</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="5" md="5" lg="5">
                    <span class="font-weight-bold"
                      >{{ $t("society.requestDetails.name") }} :
                    </span>
                  </v-col>
                  <v-col cols="6" sm="7" md="7" lg="7">
                    <span>{{ society.name }}</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="5" md="5" lg="5">
                    <span class="font-weight-bold"
                      >{{ $t("society.requestDetails.address") }} :
                    </span>
                  </v-col>
                  <v-col cols="6" sm="7" md="7" lg="7">
                    <span>{{
                      `${society.address} , ${society.city}, ${society.state}, ${society.country}`
                    }}</span>
                  </v-col>
                </v-row>
                <!-- <v-row>
                  <v-col cols="6" sm="5" md="5" lg="5">
                    <span class="font-weight-bold"
                      >{{ $t("society.requestDetails.latitude") }} :
                    </span>
                  </v-col>
                  <v-col cols="6" sm="7" md="7" lg="7">
                    <span>{{ society.latitude }}</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="5" md="5" lg="5">
                    <span class="font-weight-bold"
                      >{{ $t("society.requestDetails.longitude") }} :
                    </span>
                  </v-col>
                  <v-col cols="6" sm="7" md="7" lg="7">
                    <span>{{ society.longitude }}</span>
                  </v-col>
                </v-row> -->
                <v-row>
                  <v-col cols="6" sm="5" md="5" lg="5">
                    <span class="font-weight-bold"
                      >{{ $t("society.requestDetails.noOfHouse") }} :
                    </span>
                  </v-col>
                  <v-col cols="6" sm="7" md="7" lg="7">
                    <span>{{ society.no_of_house }}</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="5" md="5" lg="5">
                    <span class="font-weight-bold"
                      >{{ $t("society.requestDetails.noOfShop") }} :
                    </span>
                  </v-col>
                  <v-col cols="6" sm="7" md="7" lg="7">
                    <span>{{ society.no_of_shop }}</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="5" md="5" lg="5">
                    <span class="font-weight-bold"
                      >{{ $t("society.requestDetails.currency") }} :
                    </span>
                  </v-col>
                  <v-col cols="6" sm="7" md="7" lg="7">
                    <span>{{ society.currency }}</span>
                  </v-col>
                </v-row>
              </v-col>
              <v-divider
                vertical
                class="d-none d-lg-flex d-md-flex d-lg-none"
              ></v-divider>
              <v-col cols="12" sm="12" md="6">
                <v-row>
                  <v-col cols="6" sm="5" md="5" lg="5">
                    <span class="font-weight-bold"
                      >{{ $t("society.requestDetails.contactPersonName") }} :
                    </span>
                  </v-col>
                  <v-col cols="6" sm="7" md="7" lg="7">
                    <span>{{ society.contact_person_name }}</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="5" md="5" lg="5">
                    <span class="font-weight-bold"
                      >{{ $t("society.requestDetails.contactPersonNumber") }} :
                    </span>
                  </v-col>
                  <v-col cols="6" sm="7" md="7" lg="7">
                    <span>{{
                      "+" +
                      society.country_code +
                      " " +
                      society.contact_person_number
                    }}</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="5" md="5" lg="5">
                    <span class="font-weight-bold"
                      >{{ $t("society.requestDetails.contactPersonEmail") }} :
                    </span>
                  </v-col>
                  <v-col cols="6" sm="7" md="7" lg="7">
                    <span>{{
                      society.contact_person_email
                        ? society.contact_person_email
                        : "N/A"
                    }}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="mt-5 mb-1">
              <v-col cols="12">
                <v-btn
                  color="green"
                  dark
                  class="mr-5"
                  @click="confirmAcceptSocietyRequest"
                  :loading="loading"
                  width="12%"
                >
                  <v-icon left> mdi-check-bold </v-icon>
                  {{ $t("society.requestDetails.buttons.approve") }}
                </v-btn>

                <v-btn
                  color="red"
                  dark
                  @click="confirmRejectSocietyRequest"
                  :loading="loading"
                  width="12%"
                >
                  <v-icon left> mdi-close </v-icon>
                  {{ $t("society.requestDetails.buttons.reject") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-dialog v-model="AcceptDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Confirm!!
          </v-card-title>
          <v-card-text class="mt-2">Are you sure want to Approve? </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="acceptSocietyRequest(accept_id)"
            >
              yes
            </v-btn>
            <v-btn color="primary" text @click="closeDialog"> No </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="RejectDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Confirm!!
          </v-card-title>
          <v-card-text class="mt-2">Are you sure want to Reject? </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="rejectSocietyRequest(reject_id)"
            >
              yes
            </v-btn>
            <v-btn color="primary" text @click="closeDialog"> No </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      loading: false,
      society_id: "",
      society: {
        name: "",
      },
      accept_id: "",
      reject_id: "",
      AcceptDialog: false,
      RejectDialog: false,
      residentTypes: [
        {
          id: 1,
          name: "Residential",
        },
        {
          id: 2,
          name: "Commercial",
        },
        {
          id: 3,
          name: "Residential & Commercial",
        },
      ],
    };
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    getSocietyDetails() {
      let _self = this;

      _self.$axios
        .get(`superadmin/society/${this.society_id}`)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            _self.society = data.society;
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    residentType(societyType) {
      let residenttype = this.residentTypes.find(
        (type) => type.id == societyType
      );
      return residenttype ? residenttype.name : "N/A";
    },
    acceptSocietyRequest() {
      let _self = this;
      _self.loading = true;

      _self.$axios
        .post(`superadmin/society/approve/${this.society_id}`)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            _self.loading = false;
            _self.$router.push({ path: "/superadmin/society/requests" });
            _self.setAlert({
              showAlert: true,
              variant: "green accent-4",
              timeout: "2000",
              message: data.message,
            });
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    rejectSocietyRequest() {
      let _self = this;
      _self.loading = true;

      _self.$axios
        .post(`superadmin/society/reject/${this.society_id}`)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            _self.loading = false;
            _self.$router.push({ path: "/superadmin/society/requests" });
            _self.setAlert({
              showAlert: true,
              variant: "green accent-4",
              timeout: "2000",
              message: data.message,
            });
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    confirmAcceptSocietyRequest() {
      (this.AcceptDialog = true)
    },
    confirmRejectSocietyRequest() {
      (this.RejectDialog = true)
    },
    closeDialog() {
      this.AcceptDialog = false;
      this.RejectDialog = false;
      this.accept_id = "";
      this.reject_id = "";
    },
  },
  mounted() {
    this.society_id = this.$route.params.id;
    this.getSocietyDetails();
  },
};
</script>